<mat-tab-group class="at-filter-tab-wrapper" [ngClass]="{'tab': !setFeedOnRightSidebar}" id="tab_header"
               [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabIndexChange($event)">
  <mat-tab>
    <ng-template mat-tab-label>
      {{activityFilterViewModel ? activityFilterViewModel.isDraft ? 'New Filter' : 'Edit Filter' : 'New Filter'}}
    </ng-template>
    <div class="link-buttons flex flex-col justify-end items-center"
         *ngIf="setFeedOnRightSidebar && activityFilterViewModel && !isDrityFilter">
      <a class="link-button" (click)="saveFilterOnRightSideBar($event)">
        <i class="fal fa-tag"></i> {{'Save As New Filter'}}
      </a>
    </div>
    <div class="scroll" *ngIf="activityFilterViewModel">
      <form
        (keydown.enter)="$event.preventDefault()"
        [formGroup]="activityFilterForm"
        class="w-p-100 flex flex-col"
      >
        <div class="title">
          Activity
        </div>
        <mat-form-field class="checkbox-container">
          <input
            matInput
            style="display: none;"
            particleAnalytics
            analyticsCategory="choice-filter-modal-item-editor"
            analyticsAction="entity-scope-input"
          />

          <ng-container formArrayName="activityTypesArray">
            <ul class="checkbox-container">
              <li [ngClass]="{'checked': activityFilterViewModel.activities[i].isChecked}"
                  *ngFor="let activityType of activityFilterViewModel.activities; let i=index">
                <mat-checkbox
                  [checked]="activityType.isChecked"
                  [formControlName]="i"
                  (change)="onTypeCheckboxChange(i)"
                >
                  <div class="flex flex-col">
                    <span>{{activityType.text}}</span>
                  </div>
                </mat-checkbox>
              </li>
            </ul>
          </ng-container>
        </mat-form-field>
        <div class="title">
          Contacts
        </div>
        <mat-form-field class="w-p-100">
          <input
            matInput
            style="display: none;"
            particleAnalytics
            analyticsCategory="choice-filter-modal-item-editor"
            analyticsAction="entity-scope-input"
          />

          <ng-container
            formArrayName="usersRolesArray"
            *ngIf="userRoleOptions"
          >
            <ul class="checkbox-container">
              <li *ngFor="let role of activityFilterViewModel.users; let i=index"
                  [ngClass]="{'checked': activityFilterViewModel.users[i].isChecked}" class="flex flex-row">
                <mat-checkbox
                  [checked]="role.isChecked"
                  [formControlName]="i"
                  (change)="onRoleCheckboxChange(i)">
                  <div class="flex flex-col">
                    <span>{{role.text}}</span>
                  </div>
                </mat-checkbox>
                <div class="links flex flex-row justify-end items-center"
                     *ngIf="activityFilterViewModel?.users[i]?.isChecked">
                  <a class="link-color" (click)="onUserRoleOptionClick(role,i)">{{role.editor?.displayText}}</a>
                </div>
              </li>
            </ul>
          </ng-container>
        </mat-form-field>
        <div class="title">
          Data
        </div>
        <mat-form-field class="w-p-100">
          <input
            matInput
            style="display: none;"
            particleAnalytics
            analyticsCategory="choice-filter-modal-item-editor"
            analyticsAction="entity-scope-input"/>

          <ng-container formArrayName="userDataArray" *ngIf="userDataOptions">
            <ul class="checkbox-container">
              <li *ngFor="let data of activityFilterViewModel.data; let i=index"
                  [ngClass]="{'checked': activityFilterViewModel.data[i].isChecked}" class="flex flex-row">
                <mat-checkbox class="w-p-100"
                              [checked]="data.isChecked"
                              [formControlName]="i"
                              (change)="onDataCheckboxChange(i)">
                  <div class="flex flex-row">
                    <span>{{data.text}}</span>
                  </div>
                </mat-checkbox>
                <div class="links flex flex-row justify-end items-center" *ngIf="data.isChecked">
                  <a class="link-color" (click)="onUserDataOptionClick(data, i)">{{data.editor?.displayText}}</a>
                </div>
              </li>
            </ul>
          </ng-container>
        </mat-form-field>
      </form>
      <div class="title">Solutions</div>
      <ul class="checkbox-container" *ngIf="activityFilterViewModel.tools">
        <li class="flex flex-row" [ngClass]="{'checked': activityFilterViewModel.tools.isChecked}">
          <mat-checkbox [(ngModel)]="activityFilterViewModel.tools.isChecked"
                        (change)="onSolutionsCheckboxChanged($event)">Solutions
          </mat-checkbox>
          <div class="links flex flex-row justify-end items-center"
               *ngIf="activityFilterViewModel.tools.isChecked">
            <a class="link-color"
               (click)="onSolutionTreeClick(activityFilterViewModel.tools)">{{activityFilterViewModel.tools.editor.displayText}}</a>
          </div>
        </li>
      </ul>
    </div>
    <particle-right-sidebar-wait-screen
      *ngIf="!activityFilterViewModel || isDrityFilter"></particle-right-sidebar-wait-screen>
  </mat-tab>
  <mat-tab *ngIf="setFeedOnRightSidebar">
    <ng-template mat-tab-label>
      {{currentTypeOfSavedFilter?.title}}
      <button mat-icon-button class="icon-dropdown-button" [matMenuTriggerFor]="filtersTypeOption">
        <i class="fal fa-ellipsis-h"></i>
      </button>
      <mat-menu
        class="activity-menu right"
        #filtersTypeOption="matMenu"
        [overlapTrigger]="false"
      >
        <button mat-menu-item (click)="onChangeFiltersType(type)" *ngFor="let type of activityFilterTypes">
          <i [class]="type.icon"></i>
          <span>{{type.title}}</span>
        </button>
      </mat-menu>
    </ng-template>
    <mat-list class="filter-container flex flex-col full-grow-no-shrink-no-basis"
              *ngIf="activityFilters && activityFilters.length > 0">
      <mat-list-item
        *ngFor="let filter of activityFilters" class="flex flex-row justify-start items-center">
        <div class="w-p-100 flex flex-row justify-start items-center">
          <a class="link-color ellipse" matTooltip="{{filter.title}}"
             (click)="dispatchFilter(filter)">{{filter.title}}</a>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="savedFilterOptions">
          <i class="far fa-ellipsis-h"></i>
        </button>
        <mat-menu
          class="activity-menu right"
          #savedFilterOptions="matMenu"
          [overlapTrigger]="false"
        >
          <!--          <button mat-menu-item>
                      <i class="far fa-pen-nib"></i>
                      <span>Edit Filter</span>
                    </button>
                    <button mat-menu-item>
                      <i class="far fa-text"></i>
                      <span>Rename Filter</span>
                    </button>
                    <button mat-menu-item>
                      <i class="far fa-paste"></i>
                      <span>Copy Filter</span>
                    </button>
                    <button mat-menu-item>
                      <i class="far fa-trash"></i>
                      <span>Delete Filter</span>
                    </button>-->
          <button mat-menu-item (click)="onShareFilter(filter)"
                  *ngIf="currentTypeOfSavedFilter && currentTypeOfSavedFilter.title !== activityFilterTypesTilte.DefaultFilter">
            <i class="far fa-share"></i>
            <span>Share Filter</span>
          </button>
          <button mat-menu-item (click)="onOpenInMainView(filter)">
            <i class="far fa-pen-nib"></i>
            <span>Open in Full Screen</span>
          </button>
          <!--          <button mat-menu-item>
                      <i class="far fa-tasks"></i>
                      <span>Open Task</span>
                    </button>-->
        </mat-menu>
      </mat-list-item>
    </mat-list>
    <div class="p-t-20 flex flex-row justify-center items-start" *ngIf="activityFilters && !activityFilters.length">
      <em> No filters found.</em>
    </div>
  </mat-tab>
</mat-tab-group>
<div class="footer flex flex-row justify-between items-center">
  <button
    *ngIf="activityFilterViewModel && selectedTabIndex===0 && !isDrityFilter"
    mat-button
    class="action-button w-p-100"
    type="button"
    color="accent"
    (click)="onApply()">
    <span>Show Activities</span>
  </button>
</div>
